<template>
  <Nav :data="data" />
  <router-view :data="data" />
  <SiteFooter :data="data" />
</template>

<script>
import Nav from '@/views/Nav.vue'
import SiteFooter from '@/views/Footer.vue'
import { fetchCcContent, getContent } from '@/content/ccContent'

// helpers de méta au niveau module (indépendants du binding `this`)
function setMetaName(name, content) {
  const el = document.querySelector(`meta[name="${name}"]`)
  if (el && content != null) el.setAttribute('content', content)
}
function setMetaProp(property, content) {
  const el = document.querySelector(`meta[property="${property}"]`)
  if (el && content != null) el.setAttribute('content', content)
}
function setCanonical(href) {
  const el = document.querySelector('link[rel="canonical"]')
  if (el && href) el.setAttribute('href', href)
}
function absolute(base, path) {
  if (!path) return null
  if (/^https?:\/\//.test(path)) return path
  return `${(base || '').replace(/\/$/, '')}${path}`
}

// applique tout le SEO depuis le contenu (Strapi plus tard) + la route courante
function applySeo(content, routePath) {
  const seo = content?.seo
  if (!seo) return
  document.documentElement.lang = seo.lang
  document.title = seo.title
  setMetaName('description', seo.description)
  setMetaName('keywords', seo.keywords)
  setMetaProp('og:title', seo.title)
  setMetaProp('og:description', seo.description)
  setMetaName('twitter:title', seo.title)
  setMetaName('twitter:description', seo.description)
  const ogImage = absolute(seo.siteUrl, seo.ogImage)
  setMetaProp('og:image', ogImage)
  setMetaName('twitter:image', ogImage)
  const url = absolute(seo.siteUrl, routePath || '/')
  setMetaProp('og:url', url)
  setCanonical(url)
}

export default {
  name: 'App',
  components: {
    Nav,
    SiteFooter
  },
  data() {
    return {
      content: null
    }
  },
  computed: {
    data() {
      return this.content || getContent()
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(content) {
        applySeo(content, this.$route?.path)
      }
    },
    $route(route) {
      applySeo(this.data, route.path)
    }
  },
  async mounted() {
    this.content = await fetchCcContent()
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  background: $white;
}
</style>
